import { imsAuthService } from "../../authentication/shared/ims-auth-service";

/**
 * `fetch` для запросов в обход RTK Query. Сессию несёт cookie, из SDK берётся
 * только CSRF-заголовок.
 */
export async function fetchWithAuth(
  url: string,
  init: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(init.headers);
  Object.entries(imsAuthService.getAuthHeaders()).forEach(([name, value]) => {
    headers.set(name, value);
  });
  headers.set("X-Requested-With", "XMLHttpRequest");

  return fetch(url, { ...init, headers, credentials: "include" });
}
